import React from 'react';
import { Progress } from '@/components/ui/progress';
import { cn } from '@/lib/utils';
import { interpolateText, FormParameterValues } from '@client/hooks/useFormParameters';
import { useNavigation } from '@client/contexts/NavigationContext';

interface MobileProgressBarProps {
  currentSectionIndex: number;
  currentSubsectionIndex: number;
  completedSubsections: Set<string>;
  visibleSections: PolicyFormSection[];
  parameters?: FormParameterValues;
}

const PolicyApplicationMobileProgressBar: React.FC<MobileProgressBarProps> = ({
  currentSectionIndex,
  currentSubsectionIndex,
  completedSubsections,
  visibleSections,
  parameters = {},
}) => {
  // Removed unused formDefinition
  const totalSubsections = visibleSections.reduce(
    (total, section) => total + section.subsections.length,
    0,
  );

  const { navigationService } = useNavigation();

  const completedCount = completedSubsections.size;

  const progressPercentage = (completedCount / totalSubsections) * 100;

  const currentSection = visibleSections[currentSectionIndex];
  const currentSubsection = currentSection?.subsections[currentSubsectionIndex];

  return (
    <div className="border-b bg-white p-4 shadow-sm md:hidden">
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-sm font-medium text-gray-900">
              {currentSection ? interpolateText(currentSection.title, parameters) : ''}
            </h3>
            <p className="text-xs text-gray-700">
              {currentSubsection ? interpolateText(currentSubsection.title, parameters) : ''}
            </p>
          </div>
          <div className="text-xs text-gray-700">
            {completedCount} of {totalSubsections}
          </div>
        </div>

        <Progress
          value={progressPercentage}
          className="h-2"
        />

        <div className="flex space-x-1">
          {visibleSections.map((section, sectionIndex) => (
            <div
              key={section.id}
              className="flex space-x-1"
            >
              {section.subsections.map((subsection, subsectionIndex) => (
                <div
                  key={subsection.id}
                  className={cn(
                    'h-1 flex-1 rounded-full',
                    navigationService.isSubsectionWarning(subsection.id)
                      ? 'bg-yellow-700'
                      : completedSubsections.has(subsection.id)
                        ? 'bg-primary'
                        : sectionIndex === currentSectionIndex &&
                            subsectionIndex === currentSubsectionIndex
                          ? 'bg-primary'
                          : 'bg-primary-200',
                  )}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PolicyApplicationMobileProgressBar;
